import * as React from "react";
const SvgFiRrComment = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-comment_svg__a)">
      <path d="M24 11.247A12.012 12.012 0 1 0 12.017 24H19a5.005 5.005 0 0 0 5-5zM22 19a3 3 0 0 1-3 3h-6.983a10.04 10.04 0 0 1-7.476-3.343 9.92 9.92 0 0 1-2.476-7.814 10.04 10.04 0 0 1 8.656-8.761Q11.368 2 12.021 2a9.92 9.92 0 0 1 6.38 2.3 10.04 10.04 0 0 1 3.6 7.042z" />
      <path d="M8 9h4a1 1 0 1 0 0-2H8a1 1 0 0 0 0 2M16 11H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2M16 15H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2" />
    </g>
    <defs>
      <clipPath id="fi-rr-comment_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrComment;
